// @ts-strict-ignore
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Input, Output, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';

import { TrackingDirective } from '../../../core/services/tracking/directive/tracking.directive';
import { RETURN_TRANSLATION_OR_KEY, TranslatePipe } from '../../pipes/translate/translate.pipe';
import { SecondaryNba } from '../nba.model';

export interface NbaEvent {
  rootEvent: Event;
  item: SecondaryNba;
}

/**
 * This component represents a _secondary_ NBA which either can be a NBA directly or an item which pops up even more NBAs.
 */
@Component({
  selector: 'cc-nba-secondary-item',
  templateUrl: './nba-secondary-item.component.html',
  styleUrl: './nba-secondary-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, TrackingDirective, AsyncPipe, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NbaSecondaryItemComponent {
  @Input() public mainItem!: SecondaryNba;
  @Input() public subItems: SecondaryNba[] = [];
  @Input() public customWidgetContainerTemplateRef: TemplateRef<HTMLElement>;
  @Input() public footnoteHintsTemplateRef: TemplateRef<HTMLElement>;

  @Output() public readonly mainItemClick: Subject<NbaEvent> = new Subject<NbaEvent>();
  @Output() public readonly subItemClick: Subject<NbaEvent> = new Subject<NbaEvent>();

  public returnTranslationOrKey = RETURN_TRANSLATION_OR_KEY;

  public onMainItemClick($event: Event, item: SecondaryNba): void {
    this.mainItemClick.next({ rootEvent: $event, item });
  }

  public onSubItemClick($event: Event, item: SecondaryNba): void {
    this.subItemClick.next({ rootEvent: $event, item });
  }
}
